import * as React from 'react';
import { Typography, FormControl, Select, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    select: {
        fontSize: '.8em',
        paddingTop: props => (props as SelectFieldStyleProps).selectFieldPadding + 'px',
        paddingBottom: props => (props as SelectFieldStyleProps).selectFieldPadding + 'px',
    },
    option: {
        fontSize: '.8em',
    },
    labelLeft: {
        lineHeight: '2.4em',
        marginRight: '10px',
    },
});

export type SelectFieldChangeHandler = (event: React.ChangeEvent<{ value: unknown }>) => any;

export type SelectFieldStyleProps = {
    selectFieldMinWidth: number
    selectFieldPadding: number,
    selectFieldFontSize: number,
}

export enum SelectLabelOrientation {
    Left = 0,
    Top = 1,
}

export interface SelectFieldProps {
    size: string,
    minWidth: number,
    label: string,
    labelOrientation: SelectLabelOrientation,
    selectedValue: string,
    disabled: boolean,
    keyValues: { key: string, value: string }[],
    onChangeHandler: SelectFieldChangeHandler
}

const SelectField = (props: SelectFieldProps) => {
    const { size, minWidth, label, labelOrientation, selectedValue, disabled, keyValues, onChangeHandler } = props;
    const [hasChanged, setHasChanged] = React.useState<boolean>(false);
    const [value, setValue] = React.useState<string>(selectedValue);
    const classes = useStyles({ selectFieldMinWidth: minWidth, 
        selectFieldPadding: size === 'lg' ? '4' : '2',
        selectFieldFontSize: size === 'lg' ? '1' : '1.3' });

    React.useEffect(() => {
        setValue(selectedValue);
    }, [selectedValue]);

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setHasChanged(true);
        setValue(event.target.value as string);
        onChangeHandler(event);
    };

    return (
        <div>
            {label !== '' && labelOrientation === SelectLabelOrientation.Top &&
                <div>
                    <Typography id={"select-label-"+label} variant="caption">
                        {label}
                    </Typography>
                </div>
            }
            {label !== '' && labelOrientation === SelectLabelOrientation.Left &&
                <Typography id={"select-label-"+label} variant="caption" className={classes.labelLeft}>
                    {label}
                </Typography>
            }
            <FormControl variant="outlined">
                <Select
                    aria-labelledby={"select-label-"+label}
                    native
                    disabled={disabled}
                    className={classes.select}
                    value={value}
                    onChange={handleChange}>
                    
                    {(!hasChanged && selectedValue === '-1') && 
                        <option value='-1' className={classes.option}>Select {label}</option>
                    }
                    
                    {
                        keyValues.map((kvp, index) => (
                            <option value={kvp.key} key={kvp.key} className={classes.option}>{kvp.value}</option>
                        ))
                    }
                </Select>
            </FormControl>
        </div>
    );
}

export default SelectField;